//@flow
export const MAIN_BANNER_DESKTOP_EDITOR_ID = 'main_banner_home_desktop_editor';
export const MAIN_BANNER_MOBILE_EDITOR_ID = 'main_banner_home_mobile_editor';
export const MAIN_BANNER_DESKTOP_ID = 'main_banner_home_desktop';
export const MAIN_BANNER_MOBILE_ID = 'main_banner_home_mobile';

export const MAIN_BANNER_FIELDS = {
  CONTENT_POSITION: 'contentPosition',
  BANNER_SIZE: 'bannerSize',
  BANNER_MARGIN: 'bannerMargin',
  IMAGE_DESKTOP: 'imagesDesktop',
  IMAGE_MOBILE: 'imagesMobile',
  BUTTON_URL_IDENTIFIER: 'buttonUrlIdentifier',
  BUTTON_URL_TYPE: 'buttonUrlType',
  TITLE: 'title',
  SUBTITLE: 'subtitle',
  BACKGROUND_COLOR: 'backgroundColor',
  BUTTON_BACKGROUND_COLOR: 'buttonBackgroundColor',
  BUTTON_TEXT_COLOR: 'buttonTextColor',
  TEXT_COLOR: 'textColor',
  BUTTON_TEXT: 'buttonText',
  VIDEO_URL: 'videoUrl',
  VIDEO_ID: 'videoId',
};

type GenericStorefrontPage = {
  path: string,
  label: string,
};

export const GENERIC_STOREFRONT_PAGES: GenericStorefrontPage[] = [
  {
    path: '/products',
    label: 'Todos los productos',
  },
  {
    path: '/products',
    label: 'Todas las categorías',
  },
  {
    path: '/information/about-us',
    label: 'Sobre nosotros',
  },
  {
    path: '/information/complaints',
    label: 'Libro de reclamaciones',
  },
  {
    path: '/information/faq',
    label: 'Preguntas frecuentes',
  },
  {
    path: '/information/refunds',
    label: 'Devoluciones',
  },
  {
    path: '/information/shipping',
    label: 'Envíos y pagos',
  },
  {
    path: '/information/terms',
    label: 'Términos y condiciones',
  },
  {
    path: '/reviews',
    label: 'Reseñas',
  },
];

export type BannerMargin = 'WITHOUT_MARGIN' | 'WITH_MARGIN';
export type BannerMarginOption = {
  label: string,
  value: BannerMargin,
};

export const BANNER_MARGIN_OPTIONS = {
  WITHOUT_MARGIN: 'WITHOUT_MARGIN',
  WITH_MARGIN: 'WITH_MARGIN',
};

export const BANNER_SHAPE_OPTIONS = {
  FLAT: 'FLAT',
  TALL: 'TALL',
};
